import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { useCarFinanceLoan } from '../../../../components/CarFinancePage/queries/hooks/useCarFinanceLoan';
import { useTotalDepositContext } from '../../contexts/TotalDepositContext';

import {
  Form,
  LoanRequest,
  Provider,
} from '../../queries/schema/carFinance.schema';

type UseFinanceSummaryProps = {
  dealerId: string;
  financeHouse: Provider;
};

const useFinanceSummary = (props: UseFinanceSummaryProps) => {
  const { dealerId, financeHouse } = props;

  const [isHirePurchaseModalOpen, setIsHirePurchaseModalOpen] = useState(false);
  const [isFullDetailsOpen, setIsFullDetailsOpen] = useState(false);

  const fullDetailsText = isFullDetailsOpen
    ? 'Hide Full Details'
    : 'Full Details';

  const { getValues, setValue } = useFormContext<Form>();

  const loanDetails = getValues('loanDetails');

  const options: LoanRequest = {
    ...loanDetails,
    monthlyInstallmentOptions: [],
    dealerId,
    financeHouse,
  };

  const { debouncedTotalDeposit, isValidDeposit } = useTotalDepositContext();

  const { data, isLoading } = useCarFinanceLoan({
    options,
    enabled: isValidDeposit,
    dependencies: [debouncedTotalDeposit, loanDetails.monthlyInstallments],
  });

  const loanData = isValidDeposit && data ? data : null;

  /**
   * BE does not return correct values for price per month
   * when the user input does not meet minimum amounts for deposit and finance
   */
  useEffect(() => {
    setValue(
      'loanDetails.pricePerMonth',
      isValidDeposit && data ? data.pricePerMonth : 0,
    );
  }, [data, isValidDeposit, setValue]);

  return {
    isLoading,
    loanData,
    fullDetailsText,
    isHirePurchaseModalOpen,
    setIsHirePurchaseModalOpen,
    isFullDetailsOpen,
    setIsFullDetailsOpen,
  };
};

export { useFinanceSummary };
